import React from 'react';
import styled from 'styled-components';
import { Select } from 'antd';
import { CaretDownOutlined, LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const StyledSelect = styled(Select)`
  display: flex;
  .ant-select-selector {
    font-size: 15px !important;
    width: 100%;
    padding: 0 !important;
    margin: 1.8px 0;
  }
  .ant-select-arrow .anticon:not(.ant-select-suffix) {
    pointer-events: none;
  }
  .ant-select-selection-search {
    width: 100%;
    inset-inline-start: 0 !important;
    inset-inline-end: 0 !important;
  }
  .ant-select-selection-item {
    padding: ${(props) => (props.bordered ? '0 7px!important' : undefined)};
  }
`;

function FormSelect({ loading, ...props }) {
  return (
    <StyledSelect
      showSearch
      suffixIcon={loading ? <LoadingOutlined /> : <CaretDownOutlined />}
      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
      placeholder='--Chọn--'
      {...props}
    />
  );
}

FormSelect.propTypes = {
  loading: PropTypes.bool,
  bordered: PropTypes.bool,
};

export default FormSelect;
